import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/verantwoordingvoortgangsrapport/";

const voortgangsrapportVerantwoordingApi = {
	get(vrId) {
		const serviceUrl = prependRoot(routePrefix + vrId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(vrVerantwoording, documenten) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.post(serviceUrl, {
			item: vrVerantwoording,
			documenten
		}, {
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default voortgangsrapportVerantwoordingApi;